export default function length(numA: number, numB: number): number {
  return Math.abs(numA - numB);
}
